import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { getUnique, getUniqueByKey } from 'src/app/constants';
import { PartsInventoryService } from 'src/app/services/parts-inventory/parts-inventory.service';
import { logErrors } from 'src/app/shared/logger';
import { NgxSpinnerService } from 'ngx-spinner';
import { DefaultService } from 'src/app/services/default.service';

@Component({
  selector: 'app-parts-edit-dialog',
  templateUrl: './parts-edit-dialog.component.html',
  styleUrls: ['./parts-edit-dialog.component.scss'],
})
export class PartsEditDialogComponent implements OnInit {
  addMasterEventEmitter = new EventEmitter();
  editMasterEventEmitter = new EventEmitter();
  namcValue = localStorage.getItem('namcvalue');
  user = localStorage.getItem('workdayId');
  userRole = localStorage.getItem('UserRoles');
  resData: any;
  warningMessage = '';
  errorMessage: string | null = null;
  master_id: any;
  master_name: any;
  key_item: any;
  data_item: any;
  business_entity: any;
  new_key_item: any;
  cstatus: any;
  showaddpopup: boolean = false;
  showeditpopup: boolean = false;
  popupname: any;
  dock: any;
  policyName: any;
  description: any;
  dataItem: any;
  enableError: boolean = false;
  userForm: UntypedFormGroup;
  partNoList = [];
  kanbanList = [];
  selectedPartNo: any;
  selectedKanban: any;

  addOrEditform: UntypedFormGroup = this.formBuilder.group(
    {
      dock: ['', Validators.required],
      policyName: ['', Validators.required],
      description: [''],
      part_no: [''],
      kanban: [''],
      maxDays: ['', Validators.required],
      minDays: ['', Validators.required],
      maxCondition: ['AN'],
      minCondition: ['AN'],
      effectiveTo: [''],
      effectiveFrom: ['', Validators.required],
      minBoxes: ['', Validators.required],
      maxBoxes: ['', Validators.required],
    },
    {
      validator: [
        (group: UntypedFormGroup) => this.validateMinMaxFields(group, 'minDays', 'maxDays', 'minDaysMoreThanMaxDays'),
        (group: UntypedFormGroup) => this.validateMinMaxFields(group, 'minBoxes', 'maxBoxes', 'minBoxesMoreThanMaxBoxes'),
        (group: UntypedFormGroup) => this.validateMinMaxFieldsValues(group, 'minDays', 'minDaysMoreThanAllowed'),
        (group: UntypedFormGroup) => this.validateMinMaxFieldsValues(group, 'maxDays', 'maxDaysMoreThanAllowed'),
        (group: UntypedFormGroup) => this.validateMinMaxFieldsValues(group, 'minBoxes', 'minBoxesMoreThanAllowed'),
        (group: UntypedFormGroup) => this.validateMinMaxFieldsValues(group, 'maxBoxes', 'maxBoxesMoreThanAllowed'),
        (group: UntypedFormGroup) => this.validateEffectiveDate(group, 'effectiveFrom', 'effectiveFromInvalid'),
        (group: UntypedFormGroup) => this.validateEffectiveDate(group, 'effectiveTo', 'effectiveToInvalid'),
        this.effectiveFromLessThaneffectiveTo,
      ],
    }
  );

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<PartsEditDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly OspService: PartsInventoryService,
    private readonly spinner: NgxSpinnerService,
    public readonly defaultService: DefaultService
  ) { }
  get addOrEdit() {
    return this.addOrEditform.controls;
  }

  nonassignedData = [];
  updatedPart_list = [];
  ngOnInit(): void {
    this.addOrEditform.get('part_no')?.disable();
    this.addOrEditform.get('kanban')?.disable();
    this.business_entity = localStorage.getItem('namcvalue');
    this.nonassignedData = this.data?.data.alreadyAssigned;
    this.updatepartList(false);
    console.log(this.data);
    this.partNoList = this.data?.partNoList;
    this.kanbanList = this.data?.partNoList;

    if (this.data?.mode === 'edit') {
      if (this.data.data) {
        // const newArray: Array<any> = this.kanbanList.filter((val) => (newArray1.includes(val.kanban)));
        const newArray = this.data.data?.children?.map((item) => ({
          item_id: item.part_no,
        }));
        // this.selectedPartNo = newArray;
        const newArray1 = this.data.data?.children?.map((item) => ({
          kanban: item.kanban,
        }));

        // Ensure part_no and kanban dropdown updates correctly
        this.addOrEditform.patchValue({
          dock: { dock: this.data.data.dock },
          policyName: this.data.data.policy_name,
          description: this.data.data.description === 'undefined' ? '' : this.data.data.description,
          maxDays: this.data.data.max_days,
          minDays: this.data.data.min_days,
          effectiveTo: this.data.data.yearweek_to === '999953' ? '' : this.data.data.yearweek_to,
          effectiveFrom: this.data.data.yearweek_from, // 333333
          minBoxes: this.data.data.min_boxes,
          maxBoxes: this.data.data.max_boxes,
          part_no: newArray, // Set part_no with item_id values
          kanban: newArray1, // Set kanban with item_id values
          maxCondition: this.data.data.maxcondition,
          minCondition: this.data.data.mincondition,
        });

        this.addOrEditform.get('dock')?.disable();
        this.addOrEditform.get('part_no')?.enable();
        this.addOrEditform.get('kanban')?.enable();
        this.onDockChange();
      }
    } else if (this.data?.mode === 'add') {
      setTimeout(() => {
        if (this.assignDefaultDock()) {
          this.onDockChange();
        }
      }, 500);
    }
  }

  effectiveFromLessThaneffectiveTo(group: UntypedFormGroup) {
    const ef = group.get('effectiveFrom').value;
    const et = group.get('effectiveTo').value;
    return ef && et && parseInt(ef) > parseInt(et) ? { efMoreThanEt: true } : null;
  }

  validateMinMaxFields(group: UntypedFormGroup, minField: string, maxField: string, errorName: string) {
    const minValue = group.get(minField).value;
    const maxValue = group.get(maxField).value;
    return minValue && maxValue && parseFloat(minValue) > parseFloat(maxValue)
      ? { [errorName]: true }
      : null;
  }

  //Check if Min Max values are under 999.99
  validateMinMaxFieldsValues(group: UntypedFormGroup, field: string, errorName: string) {
    const value = group.get(field).value;
    // if(value && isNaN(parseFloat(value))){
    //   return { ['invalidNumber']: true };
    // }
    return (value && parseFloat(value) > 999.99)
      ? { [errorName]: true } : null;
    // if(minValue && maxValue){
    //   return (parseFloat(minValue) > 999.99 || parseFloat(maxValue) > 999.99)
    //   ? { [errorName]: true }:null;
    // }else if(minValue){
    //   return parseFloat(minValue) > 999.99
    //   ? { [errorName]: true }:null;
    // }else if(maxValue){
    //   return parseFloat(maxValue) > 999.99
    //   ? { [errorName]: true }:null;
    // }
  }

  // Check if the value is 6 digits and numeric and valid year_Week
  validateEffectiveDate(group: UntypedFormGroup, fieldName: string, errorName: string) {
    const dateValue = group.get(fieldName).value;

    if (dateValue && dateValue.length === 6 && !isNaN(dateValue)) {
      const year = parseInt(dateValue.substring(0, 4), 10);
      const week = parseInt(dateValue.substring(4, 6), 10);

      if (year < 1000 || year > 9999) {
        return { [errorName]: true };
      }
      if (week < 1 || week > 53) {
        return { [errorName]: true };
      }
      return null;
    }

    if (dateValue && dateValue.length > 0) {
      return { [errorName]: true };
    } else {
      return null;
    }
  }


  submitted: boolean = false;
  // Function to check if a date is between two other dates (inclusive)
  isBetween(start, end, checkStart, checkEnd) {

    return (
      (checkStart >= start && checkEnd <= end && checkEnd >= start && checkStart <= end) ||
      (start >= checkStart && end <= checkEnd && end >= checkStart && start <= checkEnd)
    );
  }

  // Main logic to validate the input and check part validity
  addMasterDetails() {
    this.spinner.show();

    if (this.addOrEditform.invalid) {
      this.submitted = true;
      this.spinner.hide();
      return;
    }

    const addEmittedData = {
      dock: this.addOrEdit.dock.value.dock,
      policyName: this.addOrEdit.policyName.value,
      description: this.addOrEdit.description.value,
      part_no: this.addOrEdit.part_no.value,
      kanban: this.addOrEdit.kanban.value,
      minDays: this.addOrEdit.minDays.value,
      maxDays: this.addOrEdit.maxDays.value,
      effectiveTo: this.addOrEdit.effectiveTo.value.trim() || '999953',
      effectiveFrom: this.addOrEdit.effectiveFrom.value,
      minBoxes: this.addOrEdit.minBoxes.value,
      maxBoxes: this.addOrEdit.maxBoxes.value,
      minCondition: this.addOrEdit.minCondition.value,
      maxCondition: this.addOrEdit.maxCondition.value
    };

    const offset = 0;
    let selectedPartNo = [];
    let selectedKanbanList = [];
    let isCall = false;
    if (addEmittedData.part_no?.length > 0) {
      isCall = true;
      selectedPartNo = [];
      addEmittedData.part_no.forEach((element) => {
        selectedPartNo.push(element.item_id);
      });
    }

    if (addEmittedData.kanban?.length > 0) {
      isCall = true;
      selectedKanbanList = [];
      addEmittedData.kanban.forEach((element) => {
        selectedKanbanList.push(element.kanban);
      });
    }

    // call API to check validation
    if (isCall) {
      this.checkValidDataFromDB(addEmittedData, selectedPartNo, selectedKanbanList, true);
    } else {
      this.spinner.hide();
      this.addMasterEventEmitter.emit(addEmittedData);
      this.dialogeRef.close();
    }
  }
  checkValidDataFromDB(addEmittedData, selectedPartNo, selectedKanbanList, foradd: boolean) {
    const data = {
      offset: 0,
      limit: 12000,
      business_entity: this.namcValue,
      workid: this.user,
      dock: [addEmittedData.dock],
      user_role: this.userRole,
    };
    this.OspService.getpartInventoryGrid(data).subscribe({
      error: this.errorCallback,
      next: (dBres) => {
        let dBData: any = [];
        if (foradd) {
          dBData = dBres.body.data;
        } else {
          dBData = dBres.body.data.filter((item) => item.policy_id !== this.data.data.policy_id);
        }

        if (dBData?.length == 0) {
          this.errorMessage = null;
          this.spinner.hide();
          (foradd) ? this.addMasterEventEmitter.emit(addEmittedData) : this.editMasterEventEmitter.emit(addEmittedData);
          this.dialogeRef.close();
        } else {
          const emittedEffectiveFrom = parseInt(addEmittedData.effectiveFrom);
          const emittedEffectiveTo = parseInt(addEmittedData.effectiveTo);
          console.log(`selected date range = ${emittedEffectiveFrom} - ${emittedEffectiveTo}`);
          // Filter parts matching selected part numbers from the response
          const filteredParts = dBData.flatMap((item) =>
            item?.children?.filter(
              (child) => selectedPartNo.includes(child.part_no) && child.dock === addEmittedData.dock)
              .map((child) => ({
                part_no: child.part_no,
                kanban: child.kanban,
                effective_from: item.yearweek_from,
                effective_to: item.yearweek_to.trim() == null || item.yearweek_to.trim() == '' ? '999953' : item.yearweek_to.trim(),
                policy_name: item.policy_name,
              }))
          );
          console.log(filteredParts)

          // Filter parts matching selected part numbers from the response
          const filteredkanban = dBData.flatMap((item) =>
            item?.children
              ?.filter((child) => selectedKanbanList.includes(child.kanban) && child.dock === addEmittedData.dock)
              .map((child) => ({
                part_no: child.part_no,
                kanban: child.kanban,
                effective_from: item.yearweek_from,
                effective_to: item.yearweek_to.trim() == null || item.yearweek_to.trim() == '' ? '999953' : item.yearweek_to.trim(),
                policy_name: item.policy_name,
              }))
          );
          // console.log(filteredParts1);
          if (filteredParts?.length > 0 && !this.addOrEditform.get('part_no')?.disabled) {
            // Function to check if the effective dates are valid
            const checkEffectiveDates = (part) => {
              const partEffectiveFrom = parseInt(part.effective_from);
              const partEffectiveTo = parseInt(part.effective_to);

              return this.isEffectiveDateInRange(emittedEffectiveFrom, emittedEffectiveTo, partEffectiveFrom, partEffectiveTo);
            };

            // Check all filtered parts for validity
            const checkResults = filteredParts.map((part) => {
              const isValid = checkEffectiveDates(part);
              return {
                part_no: part.part_no,
                kanban: part.kanban,
                policy_name: part.policy_name,
                isEffectiveInRange: isValid,
              };
            });

            const invalidParts = checkResults.filter((result) => result.isEffectiveInRange);

            if (invalidParts?.length > 0) {
              const uniquePartNo = getUnique(
                invalidParts.map((result) => result.part_no),
                'part_no'
              );
              const uniquePolicyName = getUnique(
                invalidParts.map((result) => result.policy_name),
                'policy_name'
              );

              this.spinner.hide();
              this.errorMessage =
                'Part number(s) ' +
                uniquePartNo.join(' , ') +
                " are already part of '" +
                uniquePolicyName.join(' , ') +
                "' inventory policy with effective dates overlapping with " +
                addEmittedData.effectiveFrom +
                (addEmittedData.effectiveTo === 999953 ? '' : ' to ' + addEmittedData.effectiveTo);

            } else {
              this.spinner.hide();
              (foradd) ? this.addMasterEventEmitter.emit(addEmittedData) : this.editMasterEventEmitter.emit(addEmittedData);
              this.dialogeRef.close();
            }
          }
          else
            if (filteredkanban?.length > 0) {
              // Function to check if the effective dates are valid
              const checkEffectiveDates1 = (part) => {
                const partEffectiveFrom = parseInt(part.effective_from);
                const partEffectiveTo = parseInt(part.effective_to);

                return this.isEffectiveDateInRange(emittedEffectiveFrom, emittedEffectiveTo, partEffectiveFrom, partEffectiveTo);
              };

              // Check all filtered parts for validity
              const checkResults = filteredkanban.map((part) => {
                const isValid = checkEffectiveDates1(part);
                return {
                  part_no: part.part_no,
                  kanban: part.kanban,
                  policy_name: part.policy_name,
                  isEffectiveInRange: isValid,
                };
              });

              const invalidKanaban = checkResults.filter((result) => result.isEffectiveInRange);

              if (invalidKanaban?.length > 0) {
                const uniqueKanban = getUnique(
                  invalidKanaban.map((result) => result.kanban),
                  'kanban'
                );
                const uniquePolicyName = getUnique(
                  invalidKanaban.map((result) => result.policy_name),
                  'policy_name'
                );

                this.spinner.hide();
                this.errorMessage =
                  'kanban(s) ' +
                  uniqueKanban.join(' , ') +
                  " are already part of '" +
                  uniquePolicyName.join(' , ') +
                  "' inventory policy with effective dates overlapping with " +
                  addEmittedData.effectiveFrom +
                  (addEmittedData.effectiveTo === 999953 ? '' : ' to ' + addEmittedData.effectiveTo);

              } else {
                this.spinner.hide();
                (foradd) ? this.addMasterEventEmitter.emit(addEmittedData) : this.editMasterEventEmitter.emit(addEmittedData);
                this.dialogeRef.close();
              }
            }
            else {
              this.spinner.hide();
              (foradd) ? this.addMasterEventEmitter.emit(addEmittedData) : this.editMasterEventEmitter.emit(addEmittedData);
              this.dialogeRef.close();
            }
        }
      },
    });
  }
  editRowMasterDetails() {
    this.spinner.show();
    if (this.addOrEditform.invalid) {
      this.submitted = true;
      this.spinner.hide();
      return;
    }

    const editEmittedData = {
      dock: this.addOrEdit.dock.value.dock,
      policyName: this.addOrEdit.policyName.value,
      description: this.addOrEdit.description.value,
      part_no: this.addOrEdit.part_no.value === null ? '' : this.addOrEdit.part_no.value,
      kanban: this.addOrEdit.kanban.value === null ? '' : this.addOrEdit.kanban.value,
      minDays: this.addOrEdit.minDays.value,
      maxDays: this.addOrEdit.maxDays.value,
      effectiveTo: this.addOrEdit.effectiveTo.value.trim() || '999953',
      effectiveFrom: this.addOrEdit.effectiveFrom.value,
      minBoxes: this.addOrEdit.minBoxes.value,
      maxBoxes: this.addOrEdit.maxBoxes.value,
      minCondition: this.addOrEdit.minCondition.value,
      maxCondition: this.addOrEdit.maxCondition.value
    };
    const offset = 0;
    let selectedPartNo = [];
    let selectedKanban = [];
    let isCall = false;
    if (editEmittedData.part_no?.length > 0) {
      isCall = true;
      selectedPartNo = [];

      editEmittedData.part_no.forEach((element) => {
        selectedPartNo.push(element.item_id);
      });
    }
    if (editEmittedData.kanban?.length > 0) {
      isCall = true;
      selectedKanban = [];

      editEmittedData.kanban.forEach((element) => {
        selectedKanban.push(element.kanban);
      });
    }
    // call api to check validation effective from dataes have add parts number present in db or not if not it will allow to save
    if (isCall) {
      this.checkValidDataFromDB(editEmittedData, selectedPartNo, selectedKanban, false);
    } else {
      this.spinner.hide();
      this.editMasterEventEmitter.emit(editEmittedData);
      this.dialogeRef.close();
    }
  }
  isEffectiveDateInRange = (effectiveFrom, effectiveTo, yearweekFrom, yearweekTo) => {
    return effectiveFrom <= yearweekTo && effectiveTo >= yearweekFrom;
  };
  callRespectiveFunction() {
    let policyName = '';
    policyName = this.addOrEditform.get('policyName')?.value?.trim();
    this.addOrEditform.get('policyName').setValue(policyName);
    if (this.data?.mode === 'edit') {
      this.editRowMasterDetails();
    } else {
      this.addMasterDetails();
    }
  }

  onKeyPressNoDecimal(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);

    // Allow number keys, decimal point, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);
    const isDecimal = event.key === '.';

    // Allow number keys, decimal point, allowed keys, and prevent default for others
    if (!isNumber && !isDecimal && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onInput(event: any, formControlName: string): void {
    const input = event.target as HTMLInputElement;
    const valueControl = this.addOrEditform.get(formControlName);

    let currentValue = input.value.replace(/[^0-9.]/g, '');

    if (currentValue.startsWith('.')) {
      currentValue = '0' + currentValue;
    }

    const parts = currentValue.split('.');

    // Handle leading zero in integer part unless it's 0.x
    if (parts[0].length > 1 && parts[0].startsWith('0')) {
      parts[0] = parts[0].replace(/^0+/, '') || '0';
    }

    if (parts.length > 2) {
      currentValue = parts[0] + '.' + parts[1];
    } else {
      currentValue = parts.join('.');
    }

    if (parts.length > 1 && parts[1].length > 2) {
      currentValue = parts[0] + '.' + parts[1].slice(0, 2);
    }

    if (Number(parts[0]) > 999) {
      parts[0] = parts[0].slice(0, 3);
      currentValue = parts.join('.');
    }

    input.value = currentValue;
    valueControl?.setValue(currentValue);

  }

  onFocusOutFunction(event: any, formControlName: string): void {
    const input = event.target as HTMLInputElement;
    const valueControl = this.addOrEditform.get(formControlName);
    let currentValue = input.value.replace(/[^0-9.]/g, '');
    if (isNaN(parseFloat(input.value))) {
      currentValue = null;
      return;
    }
    const parts = currentValue.split('.');
    if (parts.length > 1 && parts[1].length <= 0) {
      currentValue = parts[0] + '.' + '00';
    }
    input.value = currentValue;
    valueControl?.setValue(currentValue);
  }

  errorCallback = (error) => {
    logErrors(error);
    this.warningMessage = 'Something went wrong! Please contact support team.';
  };

  onDockChange(): void {
    const dock = this.addOrEditform.controls.dock?.value?.dock;
    if (dock) {
      this.addOrEditform.get('part_no')?.enable();
      this.addOrEditform.get('kanban')?.enable();
    } else {
      this.addOrEditform.get('part_no')?.disable();
      this.addOrEditform.get('kanban')?.disable();
    }
    if (dock) {
      // Reset part dropdowns and reload options
      console.log(this.data.partNoList);
      const partNoList = this.data.partNoList.filter((element) => element.dock === dock);
      // Populate new part options
      const uniquePartNoList = partNoList
        // .map((item) => ({ item_id: item.item_id }))
        .filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) => t.item_id === value.item_id // Check for unique item_id
            )
        )
        .sort((a, b) => parseInt(a.item_id) - parseInt(b.item_id)); // Sort by item_id

      const uniqueKanbanList = partNoList
        // .map((item) => ({ kanban: item }))
        .filter(
          (value, index, self) =>
            index ===
            self.findIndex(
              (t) => t.kanban === value.kanban // Check for unique kanban
            )
        )
        .sort((a, b) => parseInt(a.kanban) - parseInt(b.kanban)); // Sort by item_id

      // Update dropdown options
      this.partNoList = uniquePartNoList;
      this.kanbanList = uniqueKanbanList;

      // Reset the selected value in the kanban and partNo form controls
      if (this.data?.mode === 'add') {
        this.addOrEditform.controls.part_no.reset();
        this.addOrEditform.controls.kanban.reset();
      } else if (this.data?.mode === 'edit') {
        const newArray1: Array<any> = this.data.data?.children?.map((item) => (item.kanban));
        const newArray2: Array<any> = this.kanbanList.filter((val) => (newArray1.includes(val.kanban)));
        this.selectedKanban = newArray2;
        this.updatepartList(true);

        // const newArray3: Array<any> = this.data.data?.children?.map((item) => (item.item_id));
        // const newArray4: Array<any> = this.partNoList.filter((val) => (newArray3.includes(val.item_id)));
        // this.selectedPartNo = [];
        this.selectedPartNo = newArray2;
        
        this.updatepartList(true);
        // console.log(this.nonassignedData.filter((x)=>x.dock = 'M9'));
      }
      this.addOrEditform.controls.part_no.enable();
      this.addOrEditform.controls.kanban.enable();
    }
    this.defaultService.setDockCode(JSON.stringify([{ dock: this.addOrEditform.controls.dock?.value?.dock }]));
  }
  assignDefaultDock() {
    try {
      if (this.data.dockList?.length > 0) {
        const defaultdockArray: any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)) {
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.addOrEditform.patchValue({ dock: this.data.dockList.find(item => validDocks.has(item.dock)) });
          if (this.addOrEditform.controls.dock?.value?.dock) {
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock', error);
      return false;
    }
  }
  onPartNoListChange() {

    console.log(this.selectedPartNo);
    let partNumber = [];
    partNumber = this.addOrEditform.controls.part_no?.value?.map(item => item.item_id);
    this.selectedKanban = null;
    if (partNumber?.length > 0) {
      const kanbanSelected = this.kanbanList.filter(val => partNumber.includes(val.item_id));
      if (kanbanSelected != this.selectedKanban) {
        this.selectedKanban = kanbanSelected;
      }
      this.addOrEditform.get('kanban')?.disable();
    } else {
      this.addOrEditform.get('kanban')?.enable();
    }
  }

  onKanbanChange() {
    let kanban = [];
    kanban = this.addOrEditform.controls.kanban?.value;
    console.log(kanban);
    this.selectedPartNo = null;
    if (kanban?.length > 0) {
      // const partNumberSelected = kanban.map((item) => ({ item_id: item.item_id }));
      // if (partNumberSelected != this.selectedPartNo) {
      //   this.selectedPartNo = partNumberSelected;
      // }
      this.selectedPartNo = this.selectedKanban;
      this.addOrEditform.get('part_no')?.disable();
    } else {
      this.addOrEditform.get('part_no')?.enable();
    }
  }
  updatepartList(fromedit) {
    console.log((this.data?.mode , fromedit));
    if(!fromedit)
    this.data?.partNoList.forEach((partListData) => {
      partListData.disabled = this.checkKanbanAvaibale(partListData);
    });
    if(this.data?.mode === 'edit' && fromedit)
      this.data?.partNoList.forEach((partListData) => {
        partListData.disabled = this.checkforAlreadyselected(partListData);
      });
  }
  checkforAlreadyselected(source):boolean{
    const index = this.selectedKanban.filter(target => target.kanban === source.kanban && target.dock === source.dock);
    if (index.length > 0) {return false;} 
    else{return source.disabled;}
  }
  checkKanbanAvaibale(source):boolean {
    const index = this.nonassignedData.filter(target => target.kanban === source.kanban && target.dock === source.dock);
    if (index.length > 0) {return false;} 
    else {return true;}
  }
}
